import React, { useEffect, useRef } from 'react';
import { THEME_PHASES } from '../utils/themeAccent';
import './MatrixRain.css';

const MatrixRain = () => {
  const canvasRef = useRef(null);
  const themeRef = useRef(THEME_PHASES.green);

  useEffect(() => {
    const syncTheme = () => {
      const phase = document.documentElement.dataset.accentPhase || 'green';
      themeRef.current = THEME_PHASES[phase] || THEME_PHASES.green;
    };

    syncTheme();

    const observer = new MutationObserver(syncTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-accent-phase'],
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const ctx = canvas.getContext('2d');
    if (!ctx) return undefined;

    let animationFrameId;
    let columns = 0;
    let drops = [];
    const chars = '0123456789';
    const fontSize = 22;
    const fallSpeed = 0.35;

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      columns = Math.floor(canvas.width / fontSize);
      drops = Array.from({ length: columns }, () => Math.random() * -100);
    };

    const draw = () => {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.06)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = `700 ${fontSize}px "Courier New", Consolas, monospace`;
      ctx.textBaseline = 'top';

      const { matrixBright, matrixMid } = themeRef.current;

      for (let i = 0; i < drops.length; i += 1) {
        const char = chars[Math.floor(Math.random() * chars.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;
        const roll = Math.random();

        if (roll > 0.82) {
          ctx.fillStyle = matrixBright;
        } else if (roll > 0.55) {
          ctx.fillStyle = matrixMid;
        } else {
          ctx.fillStyle = 'rgba(140, 140, 140, 0.45)';
        }

        ctx.fillText(char, x, y);

        if (y > canvas.height && Math.random() > 0.985) {
          drops[i] = 0;
        }

        drops[i] += fallSpeed;
      }

      animationFrameId = window.requestAnimationFrame(draw);
    };

    resize();
    draw();

    window.addEventListener('resize', resize);

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return <canvas ref={canvasRef} className="matrix-rain" aria-hidden="true" />;
};

export default MatrixRain;
